import * as types from '../../constants/log/evolveLogConstants';

export const evolveLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    account,
    nftUid,
    usedNftUid,
    usedBooster,
    usedSuperBooster,
    callback,
    error
  }
) => ({
  type: types.EVOLVELOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  usedNftUid,
  usedBooster,
  usedSuperBooster,
  callback,
  error
});

export const evolveLogList = (list) => ({
  type: types.EVOLVELOG_LIST,
  list
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setEvolveLogPagination = (
  page, totalCount, beginDate, endDate, searchCode, searchString
) => ({
  type: types.SET_EVOLVELOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
});

export const evolveLogPageReset = () => ({
  type: types.EVOLVELOG_PAGE_RESET,
});
